import { useEffect, useState } from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import { SupabaseAuthProvider } from '@/components/auth/SupabaseAuthProvider';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/toaster';
import { AppRouter } from '@/routes/AppRouter';

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

function App() {
  
  if (!clerkPubKey) {
    throw new Error('Missing Clerk Publishable Key');
  }
  
  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <SupabaseAuthProvider>
        <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
          <AppRouter />
          <Toaster />
        </ThemeProvider>
      </SupabaseAuthProvider>
    </ClerkProvider>
  );
}

export default App;
